import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const LegalPage = lazy(
  () => import('./LegalPage.eager').then(mod => ({default: mod.LegalPage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
